import { useParams } from 'react-router-dom'
import useUserSkill from '../../hooks/useUserSkill'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import SkillSheet from '../../componenets/SkillSheet'
import Button from 'shared/Buttons/Button/Button'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'
import { useEffect, useState } from 'react'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import userSkillsApi from '../../userSkills.api'
import eventBus from 'services/eventBus'
import { useSetRecoilState } from 'recoil'
import userSkillsTableAtom from '../../componenets/UserSkillsTable/userSkillsTable.atom'
import recoilStateUpdaters from 'recoil/recoil.stateUpdaters'

const SkillPage = () => {
  const { wait, loading: updateLoading } = useHttpLoader()
  const params = useParams()
  const id = +params.id
  const { skill, loading } = useUserSkill(id)
  const [draft, setDraft] = useState(skill)
  const setSkillsState = useSetRecoilState(userSkillsTableAtom)

  useEffect(() => {
    setDraft(skill)
  }, [skill])

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(userSkillsApi.updateSkill(draft, id), (resp) => {
      if (resp.status === 'success') {
        recoilStateUpdaters.itemUpdated(setSkillsState, resp.body)
        eventBus.pub('ntf.message', { type: 'info', message: 'Компетенция обновлена' })
      }
    })
  }

  const renderContent = () => {
    if (!draft || loading) {
      return (
        <div className='flex-page-center'>
          <ThreeDotsLoader />
        </div>
      )
    }

    return (
      <>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Компетенция</h2>
          </div>
        </div>
        <SkillSheet skill={draft} onChange={handleChange}>
          <Button theme='primary' loading={updateLoading} style={{ width: 'fit-content' }} onClick={handleSave}>
            Сохранить
          </Button>
        </SkillSheet>
      </>
    )
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>{renderContent()}</TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default SkillPage
